export default __webpack_public_path__ + "static/media/light_desktop.f8f0ca8e.svg";